import ProcessTable from './ProcessTable';

export default {
	ProcessTable
};

export { ProcessTable };
